var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.type === 'return')?_c('span',[_vm._v(" Рейс: "),_c('b',[_vm._v(_vm._s(_vm.orderTypeStr))]),_vm._v(" Паллеты: "),_c('b',[_vm._v(_vm._s(_vm.item.isPltReturn ? 'Да' : 'Нет'))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }